import { useEffect, useState } from "react";

const ChatbotWidget = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    window.CHATBOT_SITE_KEY = "rc-cb_site_003";

    const script = document.createElement("script");
    script.src = "https://rubitcube.chatbot.rubitcubedev.com/chatbot/widget.js?v=3";
    script.async = true;
    
    script.onload = () => {
      setIsLoaded(true);
    };
    
    document.body.appendChild(script);

    return () => {
      // Cleanup
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      {/* Custom floating button with animation */}
      <div className="fixed bottom-5 right-5 z-50">
        {/* Animated pulse effect around the button */}
        <div className="absolute inset-0 rounded-full bg-blue-500 animate-ping opacity-75"></div>
        
        {/* Main button */}
        <button
          onClick={() => {
            // Trigger chatbot open if available
            if (window.Chatbot && window.Chatbot.open) {
              window.Chatbot.open();
            }
          }}
          className="relative flex items-center justify-center w-14 h-14 bg-blue-600 rounded-full shadow-lg hover:bg-blue-700 transition-all duration-300 transform hover:scale-110"
        >
          {/* Chat icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
            />
          </svg>

          {/* Loading indicator while script loads */}
          {!isLoaded && (
            <div className="absolute -top-1 -right-1 w-4 h-4 bg-yellow-400 rounded-full animate-bounce"></div>
          )}
        </button>

        {/* Tooltip */}
        <div className="absolute bottom-full right-0 mb-2 px-3 py-1 bg-gray-800 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
          Chat with us
        </div>
      </div>

      {/* CSS for additional animations */}
      <style>{`
        @keyframes float {
          0% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
          100% {
            transform: translateY(0px);
          }
        }

        @keyframes glow {
          0% {
            box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.7);
          }
          70% {
            box-shadow: 0 0 0 15px rgba(59, 130, 246, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
          }
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }

        .animate-glow {
          animation: glow 2s infinite;
        }
      `}</style>
    </>
  );
};

export default ChatbotWidget;